import React from 'react';
import { RouterBreadcrumbs } from 'src/router';
import AlertList from './components/AlertList';

function Alerts() {
  return (
    <>
      <RouterBreadcrumbs />
      <AlertList />
    </>
  );
}

export default Alerts;
